import axios from "axios";

export const registerDriverAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/drivers/createDriver`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const getAllDriversAction = async (payload) => {
  console.log(payload, "payload from get all drivers");
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/drivers/allDrivers?page=${payload.page}`,
    {
      headers: {
        Authorization: payload.token,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const resetPasswordAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/drivers/resetPassword?id=${payload.id}`,
    payload.body
  );

  return response;
};

export const deleteDriverAction = async (payload) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/drivers/deleteDriver?id=${payload.id}`,
    {
      headers: {
        Authorization: payload.token,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const editDriverAction = async (payload) => {
  console.log(payload);
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/drivers/updateDriver?driverId=${payload.driverId}`,
    payload.body
  );

  return response;
};

export const searchDriverAction = async (payload) => {
  console.log(payload);
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/drivers/searchDriver?searchTerm=${payload?.searchTerm}&companyId=${payload?.companyId}`
  );

  return response;
};
